import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Layout from "../Layouts/Layout.js";
import Home from "../pages/Home.js";
import Contact from "../pages/Contact.js";
import ArticleDetail from "../pages/ArticleDetail.js";
import PageDetail from "../pages/PageDetail.js";
import Toutacticle from "../pages/Toutacticle.js";
import Toutpage from "../pages/Toutpage.js";
import NotFound from "../pages/NotFound.js";
import Calendrier from "../pages/Calendrier.js";
import CategoryDetail from "../pages/CategoryDetail.js";
import ServiceDetail from "../pages/ServiceDetail.js";
import Search from "../pages/Search.js";
import Partenaire from "../pages/Partenaire.js";
import Chambre_de_commerces from "../pages/Chambre_de_commerces.js";
import ChambreDetail from "../pages/ChambreDetail.js";
// Event registration module
import EventRegister from "../pages/EventRegister.js";
import EventRegisterLanding from "../pages/EventRegisterLanding.js";
import EventBadge from "../pages/EventBadge.js";
import Evenements from "../pages/Evenements.js";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop Component
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location.pathname]); // Trigger effect when the pathname changes

  return null; // This component doesn't render anything
};

// Updated Layout Component with ScrollToTop
const LayoutWithScroll = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      <Layout>{children}</Layout>
    </>
  );
};

// Standalone wrapper (no site Header/Footer) — used for the custom event
// landing page. It still scrolls to top on navigation, but renders the page
// directly without the website layout.
const StandaloneWithScroll = () => {
  // React Router v6 renders child routes through <Outlet/>, never through
  // props.children — a route `element` is not given children. This used to
  // read `{children}`, which is always undefined here, so /e/{slug} mounted
  // the wrapper and then rendered nothing at all: a blank page.
  //
  // LayoutWithScroll got away with the same mistake only because Layout.js
  // renders its own <Outlet/> internally.
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

// Router Configuration
export const router = createBrowserRouter([
  // ----------------------------------------------------------------------
  // Standalone event landing pages (custom layout, NO site chrome).
  // Declared BEFORE the layout branch so they render without Header/Footer.
  //   /e/{slug}        -> event registration as a custom landing page
  // ----------------------------------------------------------------------
  {
    element: <StandaloneWithScroll />,
    children: [
      { path: '/e/:slug', element: <EventRegisterLanding /> },
      { path: '/:lang/e/:slug', element: <EventRegisterLanding /> },

      // Confirmation + badges for a standalone event. Declared here so an
      // event shown without the website layout keeps that presentation right
      // through to its confirmation page, instead of suddenly dropping the
      // visitor into a site they were never shown.
      // NOTE: '/e/registration/:ref' must come BEFORE '/e/:slug' would match
      //       it — React Router ranks static segments above dynamic ones, so
      //       'registration' wins over ':slug' automatically.
      { path: '/e/registration/:ref', element: <EventBadge /> },
      { path: '/:lang/e/registration/:ref', element: <EventBadge /> },
    ],
  },

  // ----------------------------------------------------------------------
  // Everything else renders inside the standard website layout.
  // ----------------------------------------------------------------------
  {
    element: <LayoutWithScroll />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/ar', element: <Home /> },
      { path: '/en', element: <Home /> },
      { path: '/contact', element: <Contact /> },
      { path: '/ar/contact', element: <Contact /> },
      { path: '/en/contact', element: <Contact /> },
      { path: '/calendrier', element: <Calendrier /> },
      { path: '/ar/calendrier', element: <Calendrier /> },
      { path: '/en/calendrier', element: <Calendrier /> },
      { path: '/evenements', element: <Evenements /> },
      { path: '/:lang/evenements', element: <Evenements /> },
      { path: '/article/:id/:slug?', element: <ArticleDetail /> },
      { path: '/:lang/article/:id/:slug?', element: <ArticleDetail /> },
      { path: '/page/:id/:slug?', element: <PageDetail /> },
      { path: '/:lang/page/:id/:slug?', element: <PageDetail /> },
      { path: '/toutacticle', element: <Toutacticle /> },
      { path: '/:lang/toutacticle', element: <Toutacticle /> },
      { path: '/toutpage', element: <Toutpage /> },
      { path: '/:lang/toutpage', element: <Toutpage /> },
      { path: '/category/:id/:slug?', element: <CategoryDetail /> },
      { path: '/:lang/category/:id/:slug?', element: <CategoryDetail /> },
      { path: '/service/:id/:slug?', element: <ServiceDetail /> },
      { path: '/:lang/service/:id/:slug?', element: <ServiceDetail /> },
      { path: '/search', element: <Search /> },
      { path: '/:lang/search', element: <Search /> },
      { path: '/partenaire', element: <Partenaire /> },
      { path: '/:lang/partenaire', element: <Partenaire /> },
      { path: '/chambre_de_commerces', element: <Chambre_de_commerces /> },
      { path: '/:lang/chambre_de_commerces', element: <Chambre_de_commerces /> },
      { path: '/chambre_de_commerce/:id/:slug?', element: <ChambreDetail /> },
      { path: '/:lang/chambre_de_commerce/:id/:slug?', element: <ChambreDetail /> },

      // Event registration WITH the standard website template
      { path: '/event/:slug/register', element: <EventRegister /> },
      { path: '/:lang/event/:slug/register', element: <EventRegister /> },

      // Registration confirmation + badge downloads (also the payment return URL)
      { path: '/event/registration/:ref', element: <EventBadge /> },
      { path: '/:lang/event/registration/:ref', element: <EventBadge /> },

      { path: '*', element: <NotFound /> },
    ],
  },
]);

// Export RouterProvider
export const AppRouter = () => {
  return <RouterProvider router={router} />;
};